import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { IGenericModel } from '../models/common/generic-model.model';

export enum MICRO_SERVICES {
  MS_USERS = 'ms_users',
  MS_STOCKS = 'ms_stocks',
  MS_NOTIF = 'ms_notif',
  MS_ALERTING = 'ms_alerting',
  MS_DATA = 'ms_data'
}

@Injectable()
export class ApiService<T extends IGenericModel | {}> {
  constructor(private http: HttpClient) {}

  get(
      microService: MICRO_SERVICES,
      path: string,
      params: HttpParams = new HttpParams()
  ): Observable<any> {
    return this.http
        .get(`${environment.api_base_urls[microService]}${path}`, { params })
        .pipe(catchError(this.formatErrors));
  }

  post(
      microService: MICRO_SERVICES,
      path: string,
      body: Object = {}
  ): Observable<any> {
    return this.http
        .post(`${environment.api_base_urls[microService]}${path}`, body, {
          headers: this.buildHeader()
        })
        .pipe(catchError(this.formatErrors));
  }

  patch(
      microService: MICRO_SERVICES,
      path: string,
      body: Object = {}
  ): Observable<any> {
    return this.http
        .patch(`${environment.api_base_urls[microService]}${path}`, body, {
          headers: this.buildHeader()
        })
        .pipe(catchError(this.formatErrors));
  }

  delete(microService: MICRO_SERVICES, path: string): Observable<any> {
    return this.http
        .delete(`${environment.api_base_urls[microService]}${path}`)
        .pipe(catchError(this.formatErrors));
  }

  private formatErrors(error: any): any {
    return throwError(() => error.error);
  }

  private buildHeader(token?: string): HttpHeaders {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (token) {
      headers = headers.append('Authorization', 'Bearer ' + token);
    }
    return headers;
  }
}
